import { classesConstants as classes } from "../../../constants/classes";

const initialState = {
  loading: true,
  list: [],
  classe: null,
  toCreate: null,
  myNowClasses: [],
  myClasses: [],
  myAllClasses: [],
  etudiants: [],
  inscriptions: [],
  abandons: [],
};

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case classes.GET_CLASSES:
      return {
        ...state,
        loading: false,
        list: payload,
      };
    case classes.GET_MY_CLASSES:
      return {
        ...state,
        loading: false,
        myClasses: payload,
      };
    case classes.GET_MY_NOW_CLASSES:
      return {
        ...state,
        loading: false,
        myNowClasses: payload,
      };
    case classes.GET_MY_ALL_CLASSES:
      return {
        ...state,
        loading: false,
        myAllClasses: payload,
      };
    case classes.GET_ETUDIANTS:
      return {
        ...state,
        loading: false,
        etudiants: payload,
      };
    case classes.GET_INSCRIPTIONS:
      return {
        ...state,
        loading: false,
        inscriptions: payload,
      };
    case classes.GET_ABANDONS:
      return {
        ...state,
        loading: false,
        abandons: payload,
      };
    case classes.GET_CLASSE:
      return {
        ...state,
        loading: false,
        classe: payload,
      };
    case classes.CREATE:
      return {
        ...state,
        loading: false,
        toCreate: payload,
      };
    default:
      return state;
  }
}
